import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken } from '@angular/common/http';

import { Observable } from 'rxjs';

export const IS_CACHE_DISABLED = new HttpContextToken<boolean>(() => false);
@Injectable()
export class DisableCacheInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.context.get(IS_CACHE_DISABLED) === false) {
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
    }
    if (request.context.has(IS_CACHE_DISABLED)) {
      request.context.delete(IS_CACHE_DISABLED);
    }
    return next.handle(request);
  }
}
